import React, { createContext, useContext, useState, useEffect } from 'react';
import { authEvents } from '../utils/authEvents';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showLoginModal, setShowLoginModal] = useState(false);

    useEffect(() => {
        // Check localStorage for token on load
        const token = localStorage.getItem('token');
        const username = localStorage.getItem('username');
        if (token && username) {
            setUser({ username, token });
        }
        setLoading(false);

        // Listen for session expiration from API
        const onSessionExpired = () => {
            setShowLoginModal(true);
        };
        authEvents.on('sessionExpired', onSessionExpired);

        return () => {
            authEvents.off('sessionExpired', onSessionExpired);
        };
    }, []);

    const login = (token, username) => {
        localStorage.setItem('token', token);
        localStorage.setItem('username', username);
        setUser({ username, token });

        // Notify API client that login succeeded
        authEvents.emit('loginSuccess');
        setShowLoginModal(false);
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading, showLoginModal, setShowLoginModal }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
